import React, { useEffect } from "react";
import { NavLink } from "react-router-dom";
import { Gauge, MapPin, PaperPlaneTilt, ChatCircleText, Truck, ShieldCheck, Receipt, DotsThreeCircle } from "@phosphor-icons/react";
import { useLang } from "@/i18n";

const CANDIDATES = [
  { to: "/portal", end: true, label: "Dashboard", icon: Gauge },
  { to: "/portal/loads", label: "Loads", icon: MapPin },
  { to: "/portal/dispatch", label: "Dispatch", icon: PaperPlaneTilt, roles: ["administrator", "owner", "dispatcher", "freight_agent"] },
  { to: "/portal/driver-messages", label: "Messages", icon: ChatCircleText, roles: ["administrator", "owner", "dispatcher", "freight_agent"] },
  { to: "/portal/my-carriers", label: "Carriers", icon: Truck, roles: ["accounting", "compliance_specialist"] },
  { to: "/portal/acquisition", label: "Acquire", icon: Truck, roles: ["carrier_acquisition"] },
  { to: "/portal/compliance", label: "Compliance", icon: ShieldCheck, roles: ["compliance_specialist"] },
  { to: "/portal/invoices", label: "Invoices", icon: Receipt, roles: ["accounting"] },
];

export default function MobileTabBar({ role, unread = {}, onMore }) {
  const { t } = useLang();
  const tabs = CANDIDATES.filter((c) => !c.roles || c.roles.includes(role)).slice(0, 4);

  useEffect(() => {
    document.body.classList.add("has-tabbar");
    return () => document.body.classList.remove("has-tabbar");
  }, []);

  const badgeFor = (to) => (to === "/portal/dispatch" ? unread.loads : to === "/portal/driver-messages" ? unread.trucks : 0) || 0;

  return (
    <nav className="lg:hidden fixed inset-x-0 bottom-0 z-30 bg-[#0A0A0A]/95 backdrop-blur-md border-t border-white/10 text-white pb-[env(safe-area-inset-bottom)]"
      data-testid="portal-mobile-tabbar" aria-label="Primary">
      <div className="grid grid-cols-5 h-16">
        {tabs.map(({ to, end, label, icon: Icon }) => {
          const n = badgeFor(to);
          return (
            <NavLink key={to} to={to} end={end} data-testid={`mobile-tab-${label.toLowerCase()}`}
              className={({ isActive }) => `relative flex flex-col items-center justify-center gap-1 text-[10px] font-bold tracking-wide transition-colors active:bg-white/10 ${isActive ? "text-[#0A84FF]" : "text-white/60"}`}>
              {({ isActive }) => (
                <>
                  <Icon size={22} weight={isActive ? "fill" : "bold"} />
                  <span className="truncate max-w-full px-1">{t(label)}</span>
                  {n > 0 && (
                    <span className="absolute top-2 right-[calc(50%-20px)] min-w-[18px] h-[18px] px-1 rounded-full bg-red-500 text-white text-[10px] font-black grid place-items-center"
                      data-testid={`mobile-tab-badge-${label.toLowerCase()}`}>{n > 99 ? "99+" : n}</span>
                  )}
                  {isActive && <span className="absolute top-0 inset-x-6 h-0.5 rounded-b bg-[#0A84FF]" />}
                </>
              )}
            </NavLink>
          );
        })}
        <button type="button" onClick={onMore} data-testid="mobile-tab-more"
          className="flex flex-col items-center justify-center gap-1 text-[10px] font-bold tracking-wide text-white/60 active:bg-white/10">
          <DotsThreeCircle size={22} weight="bold" />
          <span>{t("More")}</span>
        </button>
      </div>
    </nav>
  );
}
